import { useCallback, useState, MouseEvent } from 'react';

export const useBaseSearchFilterButton = () => {
  const [isFilterFormModalOpened, setIsFilterFormModalOpened] = useState<boolean>(false);

  const handleClick = useCallback((evt: MouseEvent<HTMLDivElement>) => {
    evt.preventDefault();
    evt.stopPropagation();

    setIsFilterFormModalOpened(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsFilterFormModalOpened(false);
  }, []);

  return {
    isFilterFormModalOpened,
    handleClick,
    handleClose,
  };
};
